"use client"

import { browserName as browser, isMobile } from "react-device-detect";
import { FaBell, FaChrome, FaDesktop, FaEdge, FaFirefox, FaMobileAlt, FaSafari } from "react-icons/fa";
import { FcNightPortrait } from "react-icons/fc";
import { ChromeInstructions } from "./PerBrowser/ChromeInstructions";
import { EdgeInstructions } from "./PerBrowser/EdgeInstructions";
import { FirefoxInstructions } from "./PerBrowser/FirefoxInstructions";
import { SafariInstructions } from "./PerBrowser/SafariInstructions";


export function NotificationInstructions() {
    const renderInstructions = () => {
        switch (browser.toLowerCase()) {
            case "chrome":
                return <ChromeInstructions isMobile={ isMobile } />
            case "firefox":
                return <FirefoxInstructions isMobile={ isMobile } />
            case "safari":
                return <SafariInstructions isMobile={ isMobile } />
            case "edge":
                return <EdgeInstructions isMobile={ isMobile } />
            default:
                return <p className="text-gray-300">אנא בדוק את הגדרות הדפדפן שלך כדי לאפשר התראות עבור אתר זה.</p>
        }
    }

    const getBrowserIcon = () => {
        switch (browser.toLowerCase()) {
            case "chrome":
                return <FaChrome className="text-4xl text-blue-400" />
            case "firefox":
                return <FaFirefox className="text-4xl text-orange-400" />
            case "safari":
                return <FaSafari className="text-4xl text-blue-300" />
            case "edge":
                return <FaEdge className="text-4xl text-blue-500" />
            default:
                return <FaBell className="text-4xl text-yellow-400" />
        }
    }

    return <>
        <div className="flex items-center justify-between -mt-4 mb-2">
            <h2 role="heading" className="text-3xl font-bold text-nfBlue-300">הפעלת התראות בדפדפן
                <span className="inline-block">
                    { isMobile && <FaMobileAlt className="inline ms-2" /> || <FaDesktop className="inline ms-2" /> }
                    { " " + browser }
                </span>
            </h2>
            { getBrowserIcon() }
        </div>
        <p className="text-gray-300 mb-6">רק כמה פעולות ונוכל לשלוח לכם התראות! - מבטיחים לא להספים.</p>
        <div className="relative flex flex-col bg-gray-700 rounded-md p-6 pb-2 shadow-inner drop-shadow-lg text-start">
            <span className="absolute top-0 start-4 -translate-y-1/2 bg-gray-700 rounded-md px-2 font-black">אז ככה:</span>
            { renderInstructions() }
            <p className="mt-4 text-sm leading-3 italic opacity-70 text-end">
                <FcNightPortrait className="inline" size={ "2em" } /> אממ אם ההוראות לא נכונות נשמח שתתקנו אותנו :)
            </p>
        </div>
    </>
}

